/**
 * Pure helpers for 422 CALENDAR_NOT_CONNECTED handling.
 * Both Hub and UnifiedTime hosts must treat this as non-retryable.
 *
 * @see CALENDAR_NOT_CONNECTED_422
 */

export const CALENDAR_NOT_CONNECTED_HTTP_STATUS = 422;
export const CALENDAR_NOT_CONNECTED_CODE = "CALENDAR_NOT_CONNECTED";

/**
 * True when an axios/fetch-style error is a calendar-not-connected 422
 * (status only — used by TanStack Query retry gates).
 */
export function isCalendarNotConnectedError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const response = (error as { response?: { status?: number } }).response;
  return response?.status === CALENDAR_NOT_CONNECTED_HTTP_STATUS;
}

/**
 * True when a 422 response body indicates calendar not connected
 * (used by apiRequest to skip retries).
 */
export function isCalendarNotConnectedResponseData(
  status: number | undefined,
  errorData: unknown,
): boolean {
  if (status !== CALENDAR_NOT_CONNECTED_HTTP_STATUS) return false;

  if (!errorData || typeof errorData !== "object") {
    return typeof errorData === "string" && errorData.toLowerCase().includes("not connected");
  }

  const data = errorData as {
    code?: string;
    error?: string;
    message?: string;
  };

  return (
    data.code === CALENDAR_NOT_CONNECTED_CODE ||
    data.error === "Microsoft Calendar is not connected" ||
    data.error === "Calendar not connected" ||
    (typeof data.message === "string" && data.message.includes("not connected"))
  );
}
